module.exports = __webpack_public_path__ + "img/Res_Mus_akl.cf8af56d.jpg";